import { Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  mustBeAtLeast_8Characters: {
    id: 'passwordRules.mustBeAtLeast_8Characters',
    defaultMessage: 'Must be at least 8 characters',
  },
  mustContainAtLeastOneUppercaseCharacter: {
    id: 'passwordRules.mustContainAtLeastOneUppercaseCharacter',
    defaultMessage: 'Must contain at least one uppercase character',
  },
  mustContainAtLeastOneLowercaseCharacter: {
    id: 'passwordRules.mustContainAtLeastOneLowercaseCharacter',
    defaultMessage: 'Must contain at least one lowercase character',
  },
  mustContainAtLeastOneNumber: {
    id: 'passwordRules.mustContainAtLeastOneNumber',
    defaultMessage: 'Must contain at least one number',
  },
  mustContainAtLeastOneSpecialCaseCharacter: {
    id: 'passwordRules.mustContainAtLeastOneSpecialCaseCharacter',
    defaultMessage: 'Must contain at least one special character',
  },
});

const PasswordRules = () => {
  const { formatMessage } = useIntl();

  const passwordRules: string[] = [
    formatMessage(messages.mustBeAtLeast_8Characters),
    formatMessage(messages.mustContainAtLeastOneNumber),
    `${formatMessage(
      messages.mustContainAtLeastOneSpecialCaseCharacter
    )} (^$*.[]{}()?-"!@#%&/\\,><':;|_~\`+=)`,
    formatMessage(messages.mustContainAtLeastOneUppercaseCharacter),
    formatMessage(messages.mustContainAtLeastOneLowercaseCharacter),
  ];
  return (
    <ul>
      {passwordRules.map((rule, index) => (
        <li key={index}>
          <Typography variant="caption">{rule}</Typography>
        </li>
      ))}
    </ul>
  );
};

export default PasswordRules;
